// NGRX
import { Action } from '@ngrx/store';
// CRUD
// Models
import { ContactRelationshipAgreementModel } from '../_models/contact-relationship-agreement.model';

export enum ContactRelationshipAgreementActionTypes {
  ContactRelationshipAgreementsPageRequested = '[Contact Relationship Agreement List Page] Contact Relationship Agreement Page Requested',
  ContactRelationshipAgreementsPageLoaded = '[Contact Relationship Agreement API] Contact Relationship Agreement Page Loaded',
  ContactRelationshipAgreementsPageCancelled = '[Contact Relationship Agreement API] Contact Relationship Agreement Page Cancelled',
  ContactRelationshipAgreementsPageToggleLoading = '[Contact Relationship Agreement] Contact Relationship Agreement Page Toggle Loading',
  ContactRelationshipAgreementActionToggleLoading = '[Contact Relationship Agreement] Contact Relationship Agreement Action Toggle Loading',
  ThrowContactRelationshipAgreementError = '[Contact Relationship Agreement] Throw Contact Relationship Error',
  ClearContactRelationshipAgreementErrors = '[Contact Relationship Agreement] Clear Contact Relationship Errors',
  ClearContactRelationshipAgreementState = '[Contact Relationship Agreement] Clear Contact Relationship State',
}

export class ContactRelationshipAgreementsPageRequested implements Action {
  readonly type =
    ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageRequested;

  constructor(public payload: { contactId: number; entityId: number }) {}
}

export class ContactRelationshipAgreementsPageLoaded implements Action {
  readonly type = ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageLoaded;

  constructor(
    public payload: {
      contactRelationshipAgreements: ContactRelationshipAgreementModel[];
      totalCount: number;
    },
  ) {}
}

export class ContactRelationshipAgreementsPageToggleLoading implements Action {
  readonly type =
    ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ContactRelationshipAgreementActionToggleLoading implements Action {
  readonly type =
    ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowContactRelationshipAgreementError implements Action {
  readonly type = ContactRelationshipAgreementActionTypes.ThrowContactRelationshipAgreementError;

  constructor(public payload: { error: any }) {}
}

export class ClearContactRelationshipAgreementErrors implements Action {
  readonly type = ContactRelationshipAgreementActionTypes.ClearContactRelationshipAgreementErrors;
}

export class ClearContactRelationshipAgreementState implements Action {
  readonly type = ContactRelationshipAgreementActionTypes.ClearContactRelationshipAgreementState;
}

export class ContactRelationshipAgreementsPageCancelled implements Action {
  readonly type =
    ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageCancelled;
}

export type ContactRelationshipAgreementActions =
  | ContactRelationshipAgreementsPageRequested
  | ContactRelationshipAgreementsPageCancelled
  | ContactRelationshipAgreementsPageLoaded
  | ContactRelationshipAgreementsPageToggleLoading
  | ContactRelationshipAgreementActionToggleLoading
  | ThrowContactRelationshipAgreementError
  | ClearContactRelationshipAgreementErrors
  | ClearContactRelationshipAgreementState;
